





































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import { mapState } from "vuex";

export default Vue.extend({
    name: "ImmowebCodeSearch",
    data: function() {
        return {
            inputId: "immowebCodeSearch-" + uuidv4(),
            searchValue: "" as string,
            debounceTimer: null as ReturnType<typeof setTimeout> | null
        };
    },
    computed: {
        ...mapState("MyClassifiedsModule", ["searchImmowebCode"])
    },
    mounted: function() {
        this.searchValue = this.searchImmowebCode || "";
    },
    beforeDestroy: function() {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
    },
    methods: {
        handleInput: function(event: Event): void {
            const target = event.target as HTMLInputElement;
            this.searchValue = target.value;
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            this.debounceTimer = setTimeout(() => {
                this.updateSearch();
            }, 300);
        },

        handleSearch: function(): void {
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            this.updateSearch();
        },

        updateSearch: function(): void {
            this.$store.commit("MyClassifiedsModule/setSearchImmowebCode", this.searchValue);
            this.$emit("search", this.searchValue);
        },

        clearSearch: function(): void {
            this.searchValue = "";
            this.$store.commit("MyClassifiedsModule/setSearchImmowebCode", "");
            this.$emit("search", "");
        }
    }
});
